export default __webpack_public_path__ + "static/media/system-b-element.c6409e1a.jpg";